enum DisciplineType {
  Backend = 0,
  Frontend,
  Platform,
  Build,
  Tools
}

export default DisciplineType;